// extracted by mini-css-extract-plugin
export default {"tabBar":"ReportMain_tabBar__qB5Xb","subTabBtn":"ReportMain_subTabBtn__lA6rY","active":"ReportMain_active__+t9dQ","subTabSlider":"ReportMain_subTabSlider__TZPTl"};